<template>
	<div
		class="modal fade"
		ref="modal"
		id="tipmodal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">
						<i class="sk-icon-dollar-sign-regular"></i>
						Custom Tip
					</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-subtitle">Add your custom tip below</div>
					<SkInput
						:ref="'tipInput'"
						:name="'Custom Tip'"
						:placeholder="'2.00'"
						:required="true"
						:validation="tipRegex"
						v-model="customTipValue"
					/>
					<button
						type="button"
						class="button button-primary"
						@click="setTipCustom"
						data-cy="tip-button"
					>
						Add Custom Tip
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 20px 5px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--gR-white2);
}

.modal-subtitle {
	font-size: 12px;
	margin-bottom: 47px;
	margin-left: 15px;
}

.modal-subtitle,
.sk-select {
	margin-bottom: 60px;
}

.modal-body button.button.button-primary {
	max-width: 100%;
	margin: 5 5px;
}

.sk-input-wrapper {
	min-width: 100%;
	margin-bottom: 60px;
}
</style>

<script>
import SkInput from "@/components/common/SkInput.vue"

export default {
	name: "TipModal",
	components: {
		SkInput
	},
	data: function () {
		return {
			customTipValue: "",
			tipRegex: /^[0-9]\d*(?:\.\d{0,2})?$/
		}
	},
	methods: {
		setTipCustom() {
			const isValid = this.$refs.tipInput.validate()
			if (isValid) {
				this.$store.dispatch("setCurrentTipPer", this.customTipValue)
				this.$store.dispatch("setCurrentTipCustom", this.customTipValue)
				$("#tipmodal").modal("hide")
			}
		},
		open() {
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>